
export enum EndGameButtonTypes {
    Rematch,
    Lobby,
    MatchmakingPlayAgain,
    NextLevel,
    Retry,
}

export function getEndGameRightButtonType(isCampaign: boolean, isMatchmakingGame: boolean, isWonByHuman: boolean) {
    if(isMatchmakingGame) return EndGameButtonTypes.MatchmakingPlayAgain
    if(isCampaign) return isWonByHuman ? EndGameButtonTypes.NextLevel : EndGameButtonTypes.Retry
    return EndGameButtonTypes.Rematch
}
